module.exports = __webpack_public_path__ + "static/img/scene-fztjs.7e01370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-fztjs.png
// module id = hIHn
// module chunks = 1